import logo from "./logo.svg";
import styled from "./ReactIcon.module.css";

const ReactIcon = function (props) {
  return (
    <div className={styled.center}>
      <button onClick={props.onClick}>
        <img
          src={logo}
          className={styled["App-logo"]}
          alt="logo"
          onClick={props.onClick}
        />
      </button>
    </div>
  );
};

export default ReactIcon;
